import { writable } from "svelte/store";
import type { Article } from "./types";
let initialArticleEntry = {
  itemId: "null",
  item: {
    name: "test",
    type: "sonstige",
  },
};

export const userbaseStore = writable(null);
export const InventoryStore = writable([]);
export const InventoryEntryStore = writable(null);
export const LogStore = writable([]);
export const ArticleStore = writable([]);

export const dbNameInventory = "inventory";
